import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation } from "react-router-dom";
import Footer from "../Shared/Footer/Footer";
import './trac.css';
import HomeNavBar from "../Shared/HomeNavBar/HomeNavBar";

const TractRoot = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const location = useLocation();

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            if (!mobile) {
                setSidebarOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Close sidebar when route changes on mobile
    useEffect(() => {
        if (isMobile) {
            setSidebarOpen(false);
        }
    }, [location.pathname, isMobile]);

    // Handle body scroll when sidebar is open on mobile
    useEffect(() => {
        if (isMobile && sidebarOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [sidebarOpen, isMobile]);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    return (
        <div>
            <HomeNavBar />
            
            {/* Mobile Sidebar Toggle Button */}
            {isMobile && (
                <button 
                    className="sidebar-toggle" 
                    onClick={toggleSidebar}
                    aria-label="Toggle Sidebar"
                >
                    <i className={sidebarOpen ? 'bi bi-x-lg' : 'bi bi-list'}></i>
                </button>
            )}

            {/* Sidebar Overlay for Mobile */}
            {isMobile && (
                <div 
                    className={`sidebar-overlay ${sidebarOpen ? 'overlay-open' : ''}`}
                    onClick={closeSidebar}
                ></div>
            )}

            {/* Sidebar */}
            <div className={`SidebarContainer ${sidebarOpen ? 'sidebar-open' : ''}`}>
                <div className="sidebar">
                    <div className="dropdown sidebar-item">
                        <div 
                            className="sidebar-title" 
                            onClick={toggleDropdown}
                            aria-expanded={dropdownOpen}
                        >
                            <span>
                                <i className='bi bi-person-gear'></i>
                                Manage User
                            </span>
                            <i className={`bi bi-chevron-${dropdownOpen ? 'up' : 'down'} toggle-btn`}></i>
                        </div>
                        <ul className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
                            <li>
                                <Link className="dropdown-item" to="/tract-chair/manage-admin" onClick={closeSidebar}>Manage Admin</Link>
                            </li>
                            <li>
                                <Link className="dropdown-item" to="/tract-chair/manage-reviewer" onClick={closeSidebar}>Manage Reviewer</Link>
                            </li>
                        </ul>
                    </div>

                    <Link to='/tract-chair/add-reviewer' className='sidebar-item plain' onClick={closeSidebar}>
                        <i className='bi bi-person-plus'></i>
                        Add Reviewer
                    </Link>

                    <Link to='/tract-chair/add-admin' className='sidebar-item plain' onClick={closeSidebar}>
                        <i className='bi bi-shield-plus'></i>
                        Add Admin
                    </Link>

                    <Link to='/tract-chair/assign-paper-to-reviewer' className='sidebar-item plain' onClick={closeSidebar}>
                        <i className='bi bi-file-earmark-arrow-up'></i>
                        Assign Paper
                    </Link>

                    <Link to='/' className='sidebar-item plain' onClick={closeSidebar}>
                        <i className='bi bi-house-door-fill'></i>
                        Home
                    </Link>
                </div>
            </div>
            
            {/* Main Content */}
            <div className="Component">
                <Outlet />
            </div>
        </div>
    );
};

export default TractRoot;